import React from 'react';
import { Reveal, Stagger, StaggerItem } from './Reveal';

const testimonials = [
  {
    name: "Saksha Bhagwan",
    profession: "Lawyer",
    location: "Bangalore",
    quote: "I absolutely loved working with Tanmayee. She curated a plan that was realistic, easy to follow, and perfectly suited to my lifestyle. Throughout the process, she were super helpful and made sure to follow up frequently, which really kept me motivated and accountable. What stood out the most was how informative and insightful they were. I learned so much about my eating habits and how to make sustainable changes. Tanmayee was incredibly sweet, supportive, and genuinely care about the progress which made it easier to keep up with. I'd highly recommend her to anyone looking for a professional yet personal approach to better nutrition."
  },
  {
    name: "Zara Khan",
    profession: "Service Industry",
    location: "USA",
    quote: "I've been working with Tanmayee and she has been amazing! She guided me in making small, manageable changes that have had a real impact on my weight loss journey—things I couldn't have figured out on my own. She also kept me accountable and was always approachable whenever I had questions or needed support."
  },
  {
    name: "Uma",
    profession: "IT",
    location: "Chennai",
    quote: "My son is a swimmer and consulting with Tanmayee for almost 6 months. She is very responsive and most caring person. My son's performance improved a lot. And also, he is happy with diet plan given by Tanmayee as she is considering my son's choice of food and giving alternatives for his dislikes. Periodic follow ups and guidance for competition are on time response which makes me hassle free experience."
  },
  {
    name: "Lakshmi",
    profession: "Homemaker",
    location: "Bangalore",
    quote: "I am very thankful Tanmayee ma'am. Before going there my son was having regular stomach problems and gut issues but now he is recovered from those problems and grown tall also. On regular basis now he is taking his food properly.. especially pasta with soya panneer sauce recipe is amazing :)"
  }
];

export const TestimonialsSection = () => {
  return (
    <section 
      id="testimonials"
      className="section-padding"
      style={{ background: 'var(--brand-off-white)' }}
    >
      <div className="container-custom">
        <div className="max-w-7xl mx-auto">
          <Reveal className="text-center mb-16">
            <h2 className="heading-1 text-balance">What Our Clients Say</h2>
            <p className="body-large mt-6" style={{ color: 'var(--brand-muted-grey)' }}>
              Real people, real results, real transformation
            </p>
          </Reveal>

          <Stagger className="grid md:grid-cols-2 gap-8" stagger={0.12}>
            {testimonials.map((testimonial, index) => (
              <StaggerItem
                key={testimonial.name}
                className="premium-card"
                data-testid={`testimonial-card-${index}`}>

                <span className="quote-mark" aria-hidden="true">"</span>

                <p
                  className="mb-8 mt-3"
                  style={{
                    fontFamily: "'Cormorant Garamond', serif",
                    fontSize: '22px',
                    lineHeight: 1.5,
                    fontStyle: 'italic',
                    color: 'var(--brand-charcoal)'
                  }}
                >
                  "{testimonial.quote}"
                </p>

                <div 
                  className="h-px w-full mb-6"
                  style={{ background: 'rgba(190, 147, 212, 0.2)' }}
                />

                <div>
                  <p className="font-semibold text-lg mb-1" style={{ color: 'var(--brand-deep-plum)' }}>
                    {testimonial.name}
                  </p>
                  <p className="body-small">
                    {testimonial.profession}, {testimonial.location}
                  </p>
                </div>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </div>
    </section>
  );
};
